import React from "react";

import { Grid, Typography } from "@material-ui/core";
import { withStyles, WithStyles } from "@material-ui/core/styles";
import { styles } from "./OtherProducts.styles";
import { ProductCard } from "../../views/productOverview/ProductCard";
import { LOGOS } from "../../views/productOverview/VenueConfig";

interface IOtherProduct {
    id: string;
    name: string;
    order: any;
    venue: string[];
}

interface IOtherProductsProps extends WithStyles<typeof styles> {
    currentProductName: string;
    otherProducts: IOtherProduct[];
}

const OtherProductsPure: React.FunctionComponent<IOtherProductsProps> = ({
    classes,
    currentProductName,
    otherProducts
}) => {
    if (otherProducts?.length === 0) return null;
    return (
        <>
            <Grid item xs={12}>
                <Typography className={classes.otherProducts} variant="h2">
                    Other products like {currentProductName}
                </Typography>
            </Grid>
            {otherProducts.map(e => {
                return (
                    <Grid key={e.id} item xs={4}>
                        <ProductCard
                            identifier={e.id}
                            title={e.name}
                            logos={e.venue.map(venue => ({ path: "../../" + LOGOS[venue], name: venue }))}
                            productOptions={e.order.buyingOptions}
                            prices={e.order}
                        />
                    </Grid>
                );
            })}
        </>
    );
};

export const OtherProducts = withStyles(styles)(OtherProductsPure);
